import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function Terraria() {
    // full-bleed iframe with its own background - suppress the global grain
    // wallpaper so it can't bleed behind it (same as the home page)
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / Terraria Server</title>
                <meta name="description" content="Modded Terraria server - Calamity, expert, large. Live status, roster, boss progression and route latency." />
                <link rel="canonical" href="https://ojee.net/terraria" />
            </Helmet>
            <iframe
                title="ojee.net terraria"
                src="/redesign-demos/terraria/index.html?v=8"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#06060a', zIndex: 1 }}
            />
        </>
    );
}

export default Terraria;
